import { Store } from '@ngrx/store';
import { Component, ElementRef, OnInit } from '@angular/core';

import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { Subscription } from 'rxjs';
import { UserProfileActions } from '@toro/common/shared/state-management/userprofile/userprofile.actions';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { environment } from '@hub-workspace/apps/hub/src/environments/environment';


@Component({
    selector: 'agreement',
    templateUrl: './agreement.component.html',
    styleUrls: ['./agreement.component.scss'],
})
export class AgreementComponent implements OnInit {

    public gender: number;
    public currentImage: string;
    public logoPath = `/assets/images/${environment.isNewBrand ? 'santander': 'toro'}-red-black-small.svg`;

    private subscription: Subscription;

    constructor(
        public element: ElementRef,
        private store: Store<AppState>,
        private utilitiesService: UtilitiesService,
    ) {
        this.subscription = this.store.select((state) => state.userProfile)
            .subscribe((result) => {
                this.gender = result.user.gender;

                const isMobile = this.utilitiesService.isMobile();

                if (isMobile) {

                    this.currentImage = this.gender === 1
                        ? 'url(/assets/images/_pages/plano-personalizado/mobile/img_personalizado_3_mob-min.jpg)'
                        : 'url(/assets/images/_pages/plano-personalizado/mobile/img_personalizado_2_mob-min.jpg)';

                } else {
                    this.currentImage = this.gender === 1
                        ? 'url(/assets/images/_pages/plano-personalizado/desktop/img_personalizado_2-min.jpg)'
                        : 'url(/assets/images/_pages/plano-personalizado/desktop/img_personalizado_3-min.jpg)';
                }
            });

        this.store.dispatch({ type: UserProfileActions.getUser });
    }

    public ngOnInit() {
        //
    }
}
